import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getSites, setSites } from "../../slices/app";
export const useSites = () => {
    const dispatch = useDispatch();
    const value = useSelector(getSites);
    const update = useCallback((updatedValue) => {
        dispatch(setSites(updatedValue));
    }, [dispatch]);
    return [value, update];
};
